<div class="col-lg-12 padding-20">
<!--    <div class="col-lg-12 padding-20" *ngIf="!searchLoading">-->
<div class="row m-0">
        <div class="col-lg-12 header block" >
            <h5 class="card-title text-secondary bold-font padding-top-5 header-title">New Client</h5>
        </div>
        <div class="col-lg-12 card-body border-right border regular-font">
            <ng-container *ngIf="!cirfClientFound">
            <p class="card-text semi-bold-font padding-top-5 message font-15 padding-bottom-20">Please enter client's name</p>
            <div class="row">
                <div class="col-12 col-lg-4 padding-left-0">
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input matInput [(ngModel)]="cirfClientNew.firstName" my-auto-focus maxlength="50">
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-4 padding-left-0" >
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input matInput [(ngModel)]="cirfClientNew.lastName" maxlength="100">
                    </mat-form-field>
                </div>
            </div>
                <div class="text-right padding-10 action-buttons">
                    <button mat-raised-button color="accent"
                            class="margin-right-10"
                            (click)="search()">Ok
                    </button>
                    <button   mat-raised-button color="white"
                              class="margin-right-10"
                              (click)="onClose()">Cancel
                    </button>
                </div>
            </ng-container>
            <ng-container *ngIf="cirfClientFound">
                <p class="card-text semi-bold-font padding-top-5 message font-15 padding-bottom-20">You entered information for this client in a previous Information Request</p>
                <div>
                    <mat-label><span class="bold-font">Name :</span> {{cirfClientFound.fullName}}</mat-label>
                </div>
                <div class="padding-top-5">
                    <mat-label><span class="bold-font">Address :</span> {{cirfClientFound.businessAddress?.fullAddress}}</mat-label>
                </div>
                <div class="padding-top-5">
                    <mat-label><span class="bold-font">Last Updated :</span> {{lastUpdateTimeStamp | date : 'MMMM dd, yyyy'}}</mat-label>
                </div>
                <p class="card-text semi-bold-font padding-top-15 message red"  *ngIf="!matchFound">Do you want to use that information?</p>
                <div class="text-right padding-10 action-buttons">
                    <button mat-raised-button color="accent"
                            class="margin-right-10"
                            (click)="ok()">Yes
                    </button>
                    <button   mat-raised-button color="white"
                              class="margin-right-10"
                              (click)="onCancel()">No
                    </button>
                </div>
            </ng-container>

        </div>
    </div>
</div>
